(function () {
  function init(root) {
    root.querySelectorAll('[data-digi-flash]:not([data-flash-initialized])').forEach(function (banner) {
      banner.dataset.flashInitialized = 'true';
      var end = Date.parse(banner.dataset.endsAt || '');
      if (!Number.isFinite(end)) return;
      var clock = banner.querySelector('[data-digi-flash-clock]');
      function update() {
        var remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        if (!remaining) {
          banner.hidden = true;
          clearInterval(timer);
          return;
        }
        banner.hidden = false;
        var days = Math.floor(remaining / 86400);
        var hours = Math.floor((remaining % 86400) / 3600);
        var minutes = Math.floor((remaining % 3600) / 60);
        var seconds = remaining % 60;
        clock.textContent = (days ? days + 'd ' : '') +
          [hours, minutes, seconds].map(function (n) { return String(n).padStart(2, '0'); }).join(':');
      }
      var timer;
      update();
      if (end > Date.now()) timer = setInterval(update, 1000);
    });
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-digi-copy-coupon]');
    if (!button) return;
    var code = button.dataset.code;
    function success() {
      button.textContent = 'Copiado!';
      clearTimeout(button._resetTimer);
      button._resetTimer = setTimeout(function () { button.textContent = 'Resgatar'; }, 2500);
    }
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(success).catch(function () { fallback(button, code, success); });
    } else {
      fallback(button, code, success);
    }
  });
  function fallback(button, code, success) {
    var field = document.createElement('textarea');
    field.value = code;
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    try { if (document.execCommand('copy')) success(); } finally { field.remove(); }
  }
  function start(event) { init(event && event.target ? event.target : document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();


(function () {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-digi-open-terms]');
    if (trigger) {
      var section = trigger.closest('.digi-product');
      var modal = section.querySelector('[data-digi-terms]');
      var template = trigger.parentElement.querySelector('[data-digi-terms-template]');
      if (!modal || !template) return;
      var content = modal.querySelector('[data-digi-terms-content]');
      content.replaceChildren(template.content.cloneNode(true));
      var title = content.querySelector('h3');
      modal.querySelector('h2').textContent = title ? title.textContent : 'Termos e condições';
      if (title) title.remove();
      modal.showModal();
      return;
    }
    var close = event.target.closest('[data-digi-close-terms]');
    if (close) close.closest('dialog').close();
    if (event.target.matches('[data-digi-terms]')) {
      var bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
    }
  });
})();
